const CancellationOfferService = {
  getDiscountedPrice: (normalPrice, discount) => {
    return Math.round(normalPrice * discount * 100) / 100;
  },
  getSavings: (normalPrice, discountedPrice, months = 1) => {
    return (normalPrice - discountedPrice) * months;
  },
  getDiscountEnd: (startDate, months) => {
    const paidUntil = new Date(startDate);
    const discountTo = new Date(paidUntil);
    discountTo.setMonth(discountTo.getMonth() + months);
    return discountTo;
  },
};

export default CancellationOfferService;